exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tap-editor-preview{display:flex;justify-content:center}.tap-editor-preview img{max-width:100%}.tap-editor-preview video{max-width:100%}", ""]);

